import { debugLogReducer } from "../helpers/debugHelper";
import { types } from "../types/types";

const initialState = {

  assistances: [],

  assistance: {},
  assistanceSaved: {},
  assistanceSelected: {},

  assistancesP: [],
  totalItemsAssistanceP: 0,
  totalPagesAssistanceP: 0,
  currentPageAssistanceP: 0,

  assistancesS: [],
  totalItemsAssistanceS: 0,
  totalPagesAssistanceS: 0,
  currentPageAssistanceS: 0,

  searchTextState: "",

  moreThanOneIsSelected: false,
  numberAssistanceSelected: 0,

  isLoadingAssistances: false
}

const countSelected = (list) => list.filter(item => item.isSelected).length;

export const assistanceReducer = (state = initialState, action) => {

  switch (action.type) {
    case types.ASSISTANCE_START_REGISTER_ADMIN:

      return {
        ...state,
        assistanceSaved: action.payload,
      };

    case types.ASSISTANCE_UPDATE:

      if (state.assistancesS.length > 0) {
        return {
          ...state,
          assistancesS: state.assistancesS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          assistancesP: state.assistancesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          assistancesP: state.assistancesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.ASSISTANCE_DELETE:

      if (state.assistancesS.length > 0) {
        return {
          ...state,
          assistancesS: state.assistancesS.filter((usr) => usr.id !== action.payload),
          assistancesP: state.assistancesP.filter((usr) => usr.id !== action.payload),
          assistanceSelected: {},
        };
      } else {
        return {
          ...state,
          assistancesP: state.assistancesP.filter((usr) => usr.id !== action.payload),
          assistanceSelected: {},
        };
      }

    case types.ASSISTANCE_START_LOADING_PAGINATED:

      return {
        ...state,
        assistancesP: action.payload.assistancesP,
        totalItemsAssistanceP: action.payload.totalItems,
        totalPagesAssistanceP: action.payload.totalPages,
        currentPageAssistanceP: action.payload.currentPage,
      };

    case types.ASSISTANCE_START_LOADING_ASSISTANCE_PAGINATED:

      return {
        ...state,
        assistancesS: action.payload.assistancesP,
        totalItemsAssistanceS: action.payload.totalItems,
        totalPagesAssistanceS: action.payload.totalPages,
        currentPageAssistanceS: action.payload.currentPage,
      };

    case types.ASSISTANCE_START_SEARCH_PAGINATED:

      return {
        ...state,
        assistancesS: action.payload.assistancesP,
        totalItemsAssistanceS: action.payload.totalItems,
        totalPagesAssistanceS: action.payload.totalPages,
        currentPageAssistanceS: action.payload.currentPage,
      };

    case types.ASSISTANCE_SELECT:

      return {
        ...state,
        assistanceSelected: action.payload,
      };

    case types.ASSISTANCE_CLEAN_SEARCH_PAGINATED:

      return {
        ...state,
        assistancesS: [],
        totalItemsAssistanceS: 0,
        totalPagesAssistanceS: 0,
        currentPageAssistanceS: 0,

        numberAssistanceSelected: 0,
      };

    case types.ASSISTANCE_CLEAN_PAGINATED:

      return {
        ...state,
        assistancesP: [],
        totalItemsAssistanceP: 0,
        totalPagesAssistanceP: 0,
        currentPageAssistanceP: 0,

      };

    case types.ASSISTANCE_SET_SEARCH_TEXT:

      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.ASSISTANCE_CLEAN_SEARCH_TEXT:

      return {
        ...state,
        searchTextState: "",
      };

    case types.ASSISTANCE_CLEAN_SAVED:

      return {
        ...state,
        assistanceSaved: {},
      };

    /*
  case types.ASSISTANCE_LIST_UPDATE_SELECTED:
    
    if (state.assistancesS.length > 0) {
      return {
        ...state,
        assistancesS: state.assistancesS.map((usr) => (usr.id === action.payload ? { ...usr, isSelected: !usr.isSelected } : usr)),

      };
    }
    break;
    */
    case types.ASSISTANCE_LIST_UPDATE_SELECTED: {
      const id = action.payload;
      const currentSelectedCount = countSelected(state.assistancesS);
      const targetItem = state.assistancesS.find(item => item.id === id);

      // Si va a seleccionar uno nuevo y ya hay 9, no hacer nada
      if (!targetItem.isSelected && currentSelectedCount >= 9) return state;

      const newAssistances = state.assistancesS.map(item =>
        item.id === id ? { ...item, isSelected: !item.isSelected } : item
      );

      const newCount = countSelected(newAssistances);

      return {
        ...state,
        assistancesS: newAssistances,
        numberAssistanceSelected: newCount,
        moreThanOneIsSelected: newCount > 1
      };
    }

    // Selección masiva (Primeros 9 o todos si hay menos)
    case types.ASSISTANCE_SELECT_ALL_LIMIT: {
      const newAssistances = state.assistancesS.map((item, index) => ({
        ...item,
        isSelected: index < 9 // Selecciona solo los primeros 9
      }));

      const newCount = countSelected(newAssistances);

      return {
        ...state,
        assistancesS: newAssistances,
        numberAssistanceSelected: newCount,
        moreThanOneIsSelected: newCount > 1
      };
    }

    // Limpiar todo
    case types.ASSISTANCE_CLEAN_ALL_SELECTED: {
      return {
        ...state,
        assistancesS: state.assistancesS.map(item => ({ ...item, isSelected: false })),
        numberAssistanceSelected: 0,
        moreThanOneIsSelected: false
      };
    }

    //Clean Without list
    case types.ASSISTANCE_CLEAN_ALL_WITHOUT_LIST: {
      return {
        ...state,
        numberAssistanceSelected: 0,
        moreThanOneIsSelected: false
      };
    }

    case types.ASSISTANCE_GET_MORE_THAN_ONE_SELECTED:

      debugLogReducer("ASSISTANCE_GET_MORE_THAN_ONE_SELECTED");

      if (state.assistancesS.length > 0) {
        return {
          ...state,
          moreThanOneIsSelected: getMoreThanOneIsSelected(state)
        };
      }
      break;

    case types.ASSISTANCE_LIST_SET_NUMBER_SELECTED:

      debugLogReducer("ASSISTANCE_LIST_SET_NUMBER_SELECTED");

      if (state.assistancesS.length > 0) {
        return {
          ...state,
          numberAssistanceSelected: action.payload
        };
      }
      break;

    case types.ASSISTANCE_CLEAN_SEARCH_INFORMATION:

      debugLogReducer(":: ASSISTANCE_CLEAN_SEARCH_INFORMATION");

      return {
        ...state,
        numberAssistanceSelected: 0
      };

    case types.ASSISTANCE_IS_LOADING:

      return {
        ...state,
        isLoadingAssistances: true
      };

    case types.ASSISTANCE_IS_LOADING_FINISH:

      return {
        ...state,
        isLoadingAssistances: false
      };

    default:
      return state;
  }
};

const getMoreThanOneIsSelected = (state) => {

  debugLogReducer(":: getMoreThanOneIsSelected");

  let flagMoreThanOne = false;
  let counterFlagMoreThanOneIsSelected = 0;

  if (state.assistancesS.length > 0) {
    state.assistancesS.forEach(element => {

      if (element.isSelected) {
        counterFlagMoreThanOneIsSelected = counterFlagMoreThanOneIsSelected + 1;
      }
    });
  }

  if (counterFlagMoreThanOneIsSelected > 1) {
    flagMoreThanOne = true;
  }

  return flagMoreThanOne;
}